<div>
    <ng-container *ngIf="requirePersonalValidation && !onPersonalInfoStep">
        <app-personal-data-request-screen
            (userContinue)="onDataUserContinue($event)">
        </app-personal-data-request-screen>
    </ng-container>
    <ng-container *ngIf="(requirePersonalValidation && onPersonalInfoStep) || modifyUserData">
        <div class="vh-100" [@fadeSlideInOut]="onPersonalInfoStep">
            <app-profile-personal [externalInstance]="true"
                                  [personal]="profileData"
                                  [configurations]="profileModelData"
                                  [hideLastName2]="true"
                                  [hideCurp]="true"
                                  [hideRfc]="true"
                                  [hideDob]="true"
                                  (confirmChanges)="checkPersonalData($event)">
            </app-profile-personal>
        </div>
    </ng-container>
    <ng-container *ngIf="requirePaymentData && !onPaymentInfoStep && !emailRequireVal && !phoneRequireVal && !requirePersonalValidation">
        <app-payment-info-request-view
            (userContinue)="onPaymentUserContinue($event)">
        </app-payment-info-request-view>
    </ng-container>
    <ng-container *ngIf="(requirePaymentData && onPaymentInfoStep) || modifyPayments">
        <div class="container pt-4">
            <app-checkout
                [loadDataAutomatically]="true"
                [expressMode]="false"
                [enableOneTapPayment]="false"
                [setDefaultPaymentOnTap]="true"
                [showHeader]="true"
                [showConfirmButton]="true"
                (selectedPaymentEv)="onSelectedPayment($event)"
                (confirmChanges)="onCheckoutConfirm($event)"
            ></app-checkout>
        </div>
    </ng-container>
    <div class="in-store-shopping-container container" [@fadeSlideInOut]="!requirePersonalValidation"
         [hidden]="requirePersonalValidation || requirePaymentData || modifyPayments || modifyUserData || emailRequireVal || phoneRequireVal">
        <div class="in-store-shopping-header py-4" *ngIf="!requirePersonalValidation">
            <div class="d-flex flex-row">
                <!--            <span class="material-symbols-rounded square-icon">location_on</span>-->
                <div class="ms-3">
                    <span class="header-pill">¡Nuevo!</span>
                    <h5 class="app-module-title m-0 mt-3">Escanea el codigo QR en un carrito inteligente</h5>
                    <p class="small-label app-module-subtitle">No se comparte información con terceros al iniciar la compra.</p>
                </div>
            </div>
        </div>
        <div class="in-store-shopping-content">
            <div class="qr py-3">
                <qr-code value="{{ qrData }}" size="200"></qr-code>
            </div>
            <div class="in-store-card card-theme-color theme-shadow mt-3"
                 (click)="openCheckoutManager()">
                <div class="d-flex flex-row">
                    <div class="me-3">
                        <span class="material-symbols-rounded square-icon">credit_card</span>
                    </div>
                    <div>
                        <p class="small-label">Esta compra se pagara con:</p>
                        <p class="medium-text">{{ paymentDesc }}</p>
                    </div>
                </div>
                <span class="material-symbols-rounded">arrow_forward</span>
            </div>
            <div class="in-store-card card-theme-color theme-shadow"
                 (click)="openDataManager()">
                <div class="d-flex flex-row">
                    <div class="me-3">
                        <span class="material-symbols-rounded square-icon">account_box</span>
                    </div>
                    <div>
                        <p class="small-label">Nombre</p>
                        <p class="medium-text">{{ nameToShow | titlecase }}</p>
                    </div>
                </div>
                <span class="material-symbols-rounded">arrow_forward</span>
            </div>
        </div>
        <div class="in-store-shopping-bottom mb-4">
            <!--        <button mat-flat-button-->
            <!--                class="role-action-btn w-100">-->
            <!--            Continuar-->
            <!--        </button>-->
        </div>
    </div>

    <!-- Email / Phone validation -->
    <ng-container *ngIf="(emailRequireVal || phoneRequireVal) && !requirePersonalValidation">
        <div class="store-message-container pt-3">
            <app-verify-checkout
                [expressMode]="false"
                [navigationActions]="false"
                [emailValidation]="emailRequireVal"
                [phoneValidation]="phoneRequireVal"
                (validationResponse)="checkValidationResult($event)">
            </app-verify-checkout>
        </div>
    </ng-container>

    <!-- Bottom dialogs to inform user about a problem -->
    <ng-template #internalError>
        <div class="store-message-container">
            <div class="store-issue-text-area">
                <p class="medium-text fw-bold py-3">Ocurrió un problema</p>
                <p class="small-label">
                    Estamos teniendo problemas para generar el QR. Por favor intenta de nuevo.
                </p>
            </div>
            <div class="multiple-separation-bottom-actions pt-3">
                <button mat-flat-button
                        class="role-action-btn w-100"
                        (click)="dismissBottom()">
                    Aceptar
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template #invalidPersonalData>
        <div class="store-message-container">
            <div class="store-issue-text-area">
                <p class="medium-text fw-bold py-3">Antes de continuar</p>
                <p class="small-label">
                    Por favor completa los campos señalados.
                </p>
            </div>
            <div class="multiple-separation-bottom-actions pt-3">
                <button mat-flat-button
                        class="role-action-btn w-100"
                        (click)="dismissBottom()">
                    Aceptar
                </button>
            </div>
        </div>
    </ng-template>
</div>